export default {
  form: {
    display_name: {
      label: 'Ravintolan nimi',
      placeholder: 'Anna ravintolan nimi',
      help: 'Käytetään sopimuksessa ja laskuissa',
    },
    store_address: {
      label: 'Myymälän osoite',
      placeholder: 'Hae osoitettasi',
      help: 'Tämän osoitteen asiakkaasi näkevät',
    },
    address: {
      label: 'Osoite',
      placeholder: 'Katu + numero',
    },
    zip_code: {
      label: 'Postinumero',
      placeholder: 'Postinumero',
    },
    city: {
      label: 'Kaupunki',
      placeholder: 'Kaupunki',
    },
    state: {
      label: 'Osavaltio',
      placeholder: 'Valitse osavaltio',
    },
    country: {
      label: 'Maa',
      help: 'Jos haluat siirtää ravintolasi toiseen maahan, ota yhteyttä tukeen',
    },
  },
  staff_notice:
    'Myymälän henkilökunta ei voi vahvistaa ravintolan nimeä ja osoitetta. Pyydä käyttöönottovastaavaasi tarkistamaan nämä tiedot.',
  toasts: {
    saved: 'Myymälän tiedot tallennettu',
    error: 'Myymälän tietoja ei voitu tallentaa',
  },
  buttons: {
    next: 'Seuraava',
  },
};
